import { C_ACCOUNT } from '_acaSrc/utility/constants';
import { ERROR_TITLE_MAPPINGS } from './MergeAccountsConstants';


export default class ErrorHandler {
    static createErrorResponse(message, title = '') {
        return {
            data: {
                errors: [{
                    message,
                    title
                }]
            }
        };
    }

    static formatConsolidateError(error) {
        const formattedErrors = { data: { errors: [] } };
        const errors = error?.data?.errors || [];

        errors.forEach((err) => {
            formattedErrors.data.errors.push({
                message: err.utdStatus,
                title: ''
            });
        });

        return formattedErrors;
    }

    static getMappedErrorTitle(errorMessage, fallbackTitle) {
        return ERROR_TITLE_MAPPINGS[errorMessage] ||
            fallbackTitle ||
            C_ACCOUNT.FORM_MESSAGING.ERROR_TITLE;
    }

    static checkConsolidateErrorStatus(error) {
        return typeof error === 'string' && error.includes('consolidate');
    }
}
